import axios from "axios";
import React, { useEffect, useState } from "react";
import { Constants } from "../../../CommonMethhods/Constants";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { partner_Api } from "../../../Configuration/Partner_URL";
import { AESEncryption, ApiResDecrypt, decryptData, formatNumber, formatNumberDec } from "../../../CommonMethhods/CommonMethods";

function PartnerBrokerageTable() {
  const PartnerClientCode = localStorage.getItem("ClientId2");
  const storeToken = localStorage.getItem("ssoToken");
  const [brokerageData, setBrokerageData] = useState();
  const [loader, setLoader] = useState(true);
  let clientCode = "";


  const getClientBrokerage = async (clientCode) => {
    let payloadValue = { ClientCode: clientCode };
    let encPayload = AESEncryption(payloadValue);
    try {
      const clientBrokerageData = await axios.post(
        DASHBOARD_CLIENT_OVERVIEW.ClientBrokerage_URL,
        `"${encPayload}"`,

        
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(clientBrokerageData?.data);
      const resp = res?.data;
      let firstElementKey = Object.keys(resp)[0];
      setBrokerageData(resp[firstElementKey]);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  useEffect(() => {
    if (PartnerClientCode) {
      clientCode = PartnerClientCode;
      getClientBrokerage(clientCode);
    }
  }, []);

  return (
    <div className="card-box brokerage-table bottom-25">
      <div className="card-title">
        <h2>{Constants.Client_Brokerage}</h2>
      </div>
      {/* {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            <> */}
      {/* {summaryData == undefined || summaryData.length <= 0 ? (
                noDataFound()
              ) : (
                <> */}

      <div className="scroll-table">
        <table className="client-brokerage-table">
          <tr>
            <th rowspan="2"> Transaction Type</th>

            <th colspan="4">Equity Cash</th>
            <th colspan="4">Equity F&O</th>
          </tr>
          <tr>
            <th colspan="2">{Constants.Intraday} </th>
            <th colspan="2">{Constants.Delivery}</th>

            <th colspan="2">{Constants.Futures}</th>
            <th colspan="2">{Constants.Options}</th>
          </tr>

          <tr>
            <td rowspan="2">Brokerage Rate</td>
            <td colspan="2">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.intraday ? (
                    brokerageData?.intraday.includes("P") ? (
                      <>
                        {brokerageData?.intraday.split("P")}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {brokerageData?.intraday.split("V")}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
            <td colspan="2">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.delivery ? (
                    brokerageData?.delivery.includes("P") ? (
                      <>
                        {brokerageData?.delivery.split("P")}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {brokerageData?.delivery.split("V")}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
            <td colspan="2">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.futures ? (
                    brokerageData?.futures.includes("P") ? (
                      <>
                        {brokerageData?.futures.split("P")}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {brokerageData?.futures.split("V")}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
            <td colspan="2">
              {loader ? (
                <SmallLoader />
              ) : (
                <>
                  {brokerageData?.options ? (
                    brokerageData?.options.includes("P") ? (
                      <>
                        {brokerageData?.options.split("P")}
                        {"%"}
                      </>
                    ) : (
                      <>
                        <i>₹ </i>
                        {formatNumberDec(brokerageData?.options.split("V"))}
                      </>
                    )
                  ) : (
                    0
                  )}
                </>
              )}
            </td>
          </tr>
        </table>
      </div>

      {/* </>
              )} */}
      {/* </>
          )} */}
    </div>
  );
}
export default PartnerBrokerageTable;
